import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export const CMS_COMPONENT_MENU_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'menu',
    isAdvanced: true,
    priority: 99,
    name: 'Menu',
    description: 'Menu Presentation',
    // image: '/common/cms/menu-component.png',
    tags: ['nav', 'menu', 'mobile', 'off-canvas'],
    fields: [
        {
            type: NICmsContentField.EFieldType.repeater,
            key: 'menu',
            title: 'Menu Items',
            itemName: 'Item',
            itemNameField: 'text',
            defaultSize: 3,
            defaultPart: {
                components: []
            },
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'color',
                    title: 'Color',
                    type: NICmsContentField.EFieldType.choice,
                    colorPreview: true,
                    options: ColorOptions,
                    description: 'Text color'
                },

                <NICmsContentField.IField>{
                    key: 'indent',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Indent',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'hide',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Hide',
                    default: false
                },
                <NICmsContentField.IComponentsField>{
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Components',
                    itemName: 'component',
                    default: []
                }
            ]
        },
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Color',
            description: 'Default text color',
            options: ColorOptions,
            colorPreview: true,
            default: ''
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: ''
        }
    ]
};
